import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { InfoTab } from './components/main/InfoTab';
import { CommonModal } from './components/modal/CommonModal';
import { useApiHook } from './hook/useApiHook';
import { AgreePrivacy } from './components/modal/AgreePrivacy';
import { EndDateModal } from './components/modal/EndDateModal';
import { closeWebview, isPc } from './utils';
import { MAIN_TAB_STATUS, SUB_TAB_STATUS } from './types/type';
import { RewardInfo } from './components/main/reward/RewardInfo';
import { TestBox } from './components/TestBox';
import { Header } from './components/main/Header';
import { ProgressInfo } from './components/main/progress/ProgressInfo';
import { MainEvent } from './components/main/main-event/MainEvent';
import { ParticipationInfo } from './components/main/participate/ParticipationInfo';
import { ImageUtils } from './utils/ImageUtils';
import { Flare } from './components/main/Flare';
import { infoStore, ParticipationStatus } from './store/infoStore';
import { MODAL_TYPE, modalStore } from './store/modalStore';
import { useDateHook } from './hook/useDateHook';

export const App = () => {
  const { isOverPrivacyDate } = useDateHook();
  const { info } = infoStore();
  const { showModal, showPrivacyModal } = modalStore();
  const [mainTab, setMainTab] = useState<MAIN_TAB_STATUS>(MAIN_TAB_STATUS.REWARD);
  const [subTab, setSubTab] = useState<SUB_TAB_STATUS>(SUB_TAB_STATUS.ONLINE);
  const { getEventInfo } = useApiHook();
  const isMobile = !isPc();

  useEffect(() => {
    if (isMobile) getEventInfo();
  }, [getEventInfo, isMobile]);

  const goMainEventTab = () => {
    if (info.status === ParticipationStatus.NO_TICKETS) {
      showModal({ modalType: MODAL_TYPE.CHECK_TICKET });
      return;
    }

    // 참가권 확인 가능이 아니라면 참가권 확인 모달을 띄움
    if (!info.status) {
      showModal({ modalType: MODAL_TYPE.CHECK_TICKET });
      return;
    }
    setMainTab(MAIN_TAB_STATUS.MAIN_EVENT);
  };

  const goOfflineTab = () => {
    setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
    setTimeout(() => {
      setSubTab(SUB_TAB_STATUS.OFFLINE);
    }, 0);
  };

  const goOnlineTab = () => {
    setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
    setSubTab(SUB_TAB_STATUS.ONLINE);
  };

  useEffect(() => {
    const userStatus = info.status;
    if (userStatus === ParticipationStatus.NOT_AGREED) {
      if (isOverPrivacyDate) {
        return;
      }

      showPrivacyModal();
      return;
    }
  }, [info.status, isOverPrivacyDate, mainTab, showPrivacyModal]);

  return (
    <Wrap>
      <Bg />
      <TestBox />
      <Flare />
      <HeaderContainer>
        {isMobile && <CloseButton src={ImageUtils.CloseIcon} onClick={closeWebview} />}
        <Header />
        <InfoTab mainTab={mainTab} setMainTab={setMainTab} setSubTab={setSubTab} />
      </HeaderContainer>
      <BottomContainer>
        <Inner>
          {mainTab === MAIN_TAB_STATUS.REWARD && <RewardInfo />}
          {mainTab === MAIN_TAB_STATUS.PARTICIPATE && (
            <ParticipationInfo subTab={subTab} setSubTab={setSubTab} />
          )}
          {mainTab === MAIN_TAB_STATUS.PROGRESS && (
            <ProgressInfo goOnlineTab={goOnlineTab} goMainEventTab={goMainEventTab} />
          )}
          {mainTab === MAIN_TAB_STATUS.MAIN_EVENT && <MainEvent goOfflineTab={goOfflineTab} />}
        </Inner>
      </BottomContainer>
      <CommonModal />
      <AgreePrivacy />
      <EndDateModal />
    </Wrap>
  );
};

const Wrap = styled.div`
  width: 100%;
  position: relative;
  z-index: 2;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const HeaderContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 820px;
  margin: 0 auto;
`;

const CloseButton = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 1;
`;

const BottomContainer = styled.div`
  position: relative;
  background: #302e2d;
  display: flex;
  flex: 1;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
`;

const Bg = styled.div`
  position: fixed;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  background: linear-gradient(164deg, #0076da 4.5%, #0043a8 24.9%, #120b38 62.84%, #070526 100.33%);
  z-index: 0;
`;
